export function calculateReturnStatement(timestamp) {
  const now = new Date();
  const targetTime = new Date(timestamp);
  const timeDifference = Math.abs(now - targetTime) / 1000;

  const days = Math.floor(timeDifference / 86400);
  const hours = Math.floor((timeDifference % 86400) / 3600);
  const minutes = Math.floor((timeDifference % 3600) / 60);
  const seconds = Math.floor(timeDifference % 60);

  if (days > 0) {
    return `${days}d`;
  }

  if (hours > 0) {
    return `${hours}h`;
  }

  if (minutes > 0) {
    return `${minutes}m`;
  }

  return `${seconds}s`;
}

export function concatenateAndTruncate(arr, maxLength, key) {
  const concatenatedString = arr
    .filter((item) => !!item[key])
    .map((item) => item[key])
    .join(" || ");

  if (concatenatedString.length <= maxLength) {
    return concatenatedString;
  } else {
    return concatenatedString.substring(0, maxLength) + "...";
  }
}

export const validateFile = (file, fileType, fileSize = 5) => {
  if (!(file && fileType && fileSize)) return;

  const type = file.type.split("/")[1];
  let fileName = file.name.split(".")[1];
  let validationRes = { errors: [] };

  switch (fileType) {
    case "image":
      if (!["png", "gif", "jpg", "jpeg"].includes(type))
        validationRes.errors.push("Upload png/jpg/jpeg image!");
      if (file.size / 1000000 > fileSize)
        validationRes.errors.push("Please upload size max of 5MB!");
      break;
    case "document":
      if (!["pdf", "doc", "docx"].includes(fileName))
        validationRes.errors.push("Upload pdf/doc file!");
      if (file.size / 1000000 > fileSize)
        validationRes.errors.push("Please upload size max of 5MB!");
      break;
    case "video":
      if (file.type.split("/")[0] !== "video")
        validationRes.errors.push("Upload Video file!");
      if (["png", "gif", "jpg", "jpeg", "pdf", "doc", "xls"].includes(type))
        // Add more video formats as needed
        validationRes.errors.push("Upload mp4, hevc, avi, mov, or wmv file!");
      //if(file.size/100000 > fileSize) validationRes.errors.push("Please upload size max of 5MB!");
      break;
    case "videoImg":
      if (["pdf", "doc", "xls"].includes(type))
        validationRes.errors.push("Upload file as image or video");
      if (file.size / 1000000 > fileSize)
        validationRes.errors.push("Please upload size max of 5MB!");
      break;
    default:
      break;
  }

  return validationRes;
};

export const parseHtmlAndReplaceEmpty = (stringToBeParsed) =>
  stringToBeParsed.replace(/(<([^>]+)>)/gi, "");

export const calendarScheduleList = () => {
  const timeArray = [];

  for (let hour = 0; hour <= 23; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const formattedHour =
        hour === 0
          ? "12"
          : hour > 12
          ? (hour - 12).toString().padStart(2, "0")
          : hour.toString().padStart(2, "0");
      const formattedHourValue = hour.toString();
      const formattedMinute = minute.toString().padStart(2, "0");
      const timeObject = {
        name: `${formattedHour}:${formattedMinute}${hour >= 12 ? "PM" : "AM"}`,
        value: `${formattedHourValue}.${formattedMinute}`,
      };
      timeArray.push(timeObject);
    }
  }
  return timeArray;
};

export const truncateText = (text, maxLength) => {
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};

export function capitalizeEachWord(inputString) {
  if (inputString.length > 0) {
    inputString = inputString.charAt(0).toUpperCase() + inputString.slice(1);
  }

  return inputString;
}

export function getUserTimeZone() {
  try {
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timeZone;
  } catch (error) {
    console.error("Error getting time zone:", error);
    return null;
  }
}

export async function imageUrlToBlob(imageUrl) {
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error("Error converting image URL to Blob:", error);
    return null;
  }
}

export function convertToAMPM(timeString) {
  const [hours, minutes] = timeString.split(".");
  let hours12 = parseInt(hours);
  const ampm = hours12 >= 12 ? "PM" : "AM";
  hours12 = hours12 % 12 || 12; // Convert 0 to 12 for 12 AM/PM
  return `${hours12}:${minutes} ${ampm}`;
}

export const numberWithCommas = (x) => {
  return x.toString().split(".")[0].length > 3
    ? x
        .toString()
        .substring(0, x.toString().split(".")[0].length - 3)
        .replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
        "," +
        x.toString().substring(x.toString().split(".")[0].length - 3)
    : x.toString();
};
